<template>
  <div class="g-bd">
    <div :class="[`w-exception-${mode.mode}`,'w-exception']">
      <i
        class="bConfirm-close"
        @click="onClose()"
      ></i>
      <div class="cnt">
        <div
          class="img"
          v-show="mode.img0"
        >
          <img :src="mode.img0" />
        </div>
        <div
          :class="['note-txt0',mode.txt1?'':'note-center']"
          v-show="mode.txt0"
          v-html="mode.txt0"
        ></div>
        <div
          class="note-txt1"
          v-show="mode.txt1"
        >
          <bCheckbox
            :label="mode.txt1"
            v-model="checkStatus"
            :name="mode.txt1"
          />
        </div>
      </div>
      <div class="btn-box">
        <div
          v-if="mode.btnTxt0"
          class="pop-btn"
          :class="mode.btnTxt1?'left':'center'"
          @click="modeClose"
        >{{mode.btnTxt0}}</div>
        <div
          v-if="mode.btnTxt1"
          class="pop-btn"
          :class="[mode.btnTxt0?'right':'center']"
          @click="onConfirm"
        >{{mode.btnTxt1}}</div>
      </div>
    </div>
  </div>
</template>

<script>
const LOADIFRAME_TIME = 5000;
import util from '../util/util';
import bCheckbox from './bCheckBox'
export default {
  name: 'mode',
  components:{
    bCheckbox
  },
  props: {
    mode:{
      type:Object,
      default:{}
    },
    toUrl:{
      type:String,
      default:''
    }
  },
  data(){
    return{
      checkStatus:false
    }
  },
  mounted(){
    window.Loading.loading = false;
  },
  methods:{
    onClose(){
    },
    modeClose(){
      let srcList = this.mode.srcList
      if(this.mode.mode===4&&srcList){
        srcList.forEach((item,index)=>{
          let _ck = this.checkStatus?'1':'0'
          srcList[index] +=`&ck=${_ck}`
        })
      }
      if(srcList&&this.mode.srcList.length>0){
        this.setDomains(this.mode.srcList,()=>{
            this.goBack()
        })
      }else{
        this.goBack()
      }
    },
    goBack(){
      if(this.mode.mode===1){
          window.open(this.mode.btnLink0)
      }else if(this.mode.mode===3||this.mode.mode===4||this.mode.mode===0){
         window.jumpLoading.loading=true;
         location.href = this.toUrl;
      }else{
        this.$emit('backLogin',{autoLogin:false})
      }
    },
    onConfirm(){
      location.href=this.mode.btnLink1
    },
      /**
         * 设置多域cookie
         */
        setDomains: (function(urls, endfunc) {
            var count = 0;
            return function(urls, endfunc) {
                if (typeof urls === 'string') {
                    util.insertFrame(urls, this.mode.opd, () => {
                        endfunc();
                    });
                } else if (urls.length > 0) {
                    count = urls.length;
                    this.sto = window.setTimeout(() => {
                        endfunc();
                    }, LOADIFRAME_TIME);
                    for (let i = 0; i < urls.length; i++) {
                        util.insertFrame(urls[i], this.mode.opd, () => {
                            count--;
                            if (count === 0) {
                                endfunc();
                                window.clearTimeout(this.sto);
                            }
                        });
                    }
                } else {
                    endfunc();
                }
            };
        })(),
  },
   beforeDestroy() {
        // @NOTE 实例销毁前清除定时器
        if (this.sto) {
            window.clearTimeout(this.sto);
        }
    },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// mode.vue?47892086